import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const FOR = ['Tienes hijos, nietos o ahijados de 6 a 14 años y quieres que conozcan la Palabra', 'Estás cansado/a de pelear para que lean “aunque sea un poquito”', 'Buscas un regalo con propósito para una Primera Comunión, cumpleaños o Navidad', 'Quieres momentos de lectura compartida en familia (funciona increíble como devocional nocturno)', 'Tú mismo/a nunca pudiste terminar la Biblia y quieres entender la historia completa'];
const NOT_FOR = ['Buscas un reemplazo de la Biblia completa (esto es la puerta de entrada, no el destino)', 'Esperas un libro físico enviado por correo (es digital: lo descargas y, si quieres, lo imprimes)', 'Prefieres que tus hijos se acerquen a la lectura sin ningún apoyo visual'];
export function ForWhoSection() {
  return <section className="w-full bg-cream" data-id="element-50" data-mp="3sl3o6yvtbp4f">
      <div className="mx-auto max-w-6xl px-4 py-16 md:py-20" data-id="element-51" data-mp="3nmiulib2g3oy">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2" data-id="element-52" data-mp="3nnbv41jflwyn">
          {/* Es para ti */}
          <div className="rounded-card border-2 border-sage/30 bg-sage/5 p-7" data-id="element-53" data-mp="1s8i1sotp5m6t">
            <h3 className="mb-5 flex items-center gap-2 font-display text-2xl font-bold text-sage" data-id="element-54" data-mp="1xa7fkc8b0dyl">
              ✅ Es para ti si...
            </h3>
            <ul className="space-y-3" data-id="element-55" data-mp="1ie9hgoetkzjq">
              {FOR.map(item => <li key={item} className="flex items-start gap-3" data-id="element-56" data-mp="1nb8d5be4tek1">
                  <CheckIcon className="mt-0.5 h-5 w-5 flex-none text-sage" aria-hidden="true" data-id="element-57" data-mp="2b1lwmdini530" />
                  <span className="text-[16px] text-ink/80" data-id="element-58" data-mp="21ar9l6xkz1gi">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* No es para ti */}
          <div className="rounded-card border border-card-border bg-white p-7" data-id="element-59" data-mp="268195feooti2">
            <h3 className="mb-5 flex items-center gap-2 font-display text-2xl font-bold text-ink/70" data-id="element-60" data-mp="2tyn5waj8mrcr">
              ❌ No es para ti si...
            </h3>
            <ul className="space-y-3" data-id="element-61" data-mp="38lvhvdkdf0ps">
              {NOT_FOR.map(item => <li key={item} className="flex items-start gap-3" data-id="element-62" data-mp="38jrh34hrqhtq">
                  <XIcon className="mt-0.5 h-5 w-5 flex-none text-ink/40" aria-hidden="true" data-id="element-63" data-mp="33nk8f3xzms83" />
                  <span className="text-[16px] text-ink/70" data-id="element-64" data-mp="2ummc77tsjp02">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}